import * as React from 'react';
import { useQuery } from "graphql-hooks";
import { Row } from 'reactstrap';
import Helper from '../utilities/helper'
import { PermissionsGate } from '../utilities/PermissionsGate';
import { ACCESS_VALUES, PageNames } from '../utilities/constValues';
import { PermissionsRequired } from './Shared/PermissionsRequired';
import { useLocation } from 'react-router-dom';
import { Loading } from './Shared/Loading';
import { MetaTags } from "./Shared/MetaTags";
import { ErrorPage } from './Shared/ErrorPage';
import { Hero } from './Shared/Hero';
import { ContentBlock } from './Shared/Content/ContentBlock';
import { ContentBody } from './Shared/Content/ContentBody';

const CMS_QUERY = `query datoQuery {
    pageData: pageTermsOfUse {
        fieldHeroTitle
        fieldBodyContent1
        seo: _seoMetaTags {
            attributes
            content
            tag
        }
    }
}
`;


export const TermsOfUse = () => {
    const { loading, error, data } = useQuery(CMS_QUERY);

    const location = useLocation();
    React.useEffect(() => {
        Helper.setPagePath(location.pathname);
    }, [location]);

    if (!error && !loading) {
        return (
            <PermissionsGate requestedPermission={ACCESS_VALUES.Resources} renderError={<PermissionsRequired showParticipantMsg={true} />} pageName={PageNames.TermsOfUse}>
            <div className="termsOfUse">
                <Hero pageTitle={data.pageData.fieldHeroTitle} />
                <ContentBlock className="termsOfUseContent">
                    <ContentBody>
                        <div dangerouslySetInnerHTML={{ __html: data.pageData.fieldBodyContent1}} />
                    </ContentBody>
                </ContentBlock>
                {/* set meta tags */}
                <MetaTags seoData={data.pageData.seo}/>
            </div>
            </PermissionsGate>
        );
    }
    else if (!error) {
        return (<Loading showContent={true} includeHero={true} />);
    }
    else {
        return (<ErrorPage showContactForm={true} includeHero={true} />);
    }
};
